<template>
<div>
    <div class='vx-col w-full mb-base'>
        <vx-card class="w-full">
            <div class="mb-3 text-left">
                <vs-button class="m-3" @click="$router.push('/support/notice/registration')" type="gradient">
                    공지사항 등록
                </vs-button>
            </div>
            <div class="flex items-center mb-3">
                <div style="width:80px">검색조건</div>
                <div class="flex items-center ml-3">
                    <v-select class="searchSelect" placeholder="검색항목" v-model="keywordType" :options="keywordOptions" :reduce="o => o.value" :clearable="false" />
                    <vs-input class="ml-2" placeholder="검색어" v-model="keyword" @keyup.enter.native="list_search" style="min-width:200px"/>
                    <vs-button class="ml-2" @click="list_search">검색</vs-button>
                    <vs-button class="ml-2" color="dark" @click="searchReset">초기화</vs-button>
                </div>
            </div>
        </vx-card>
    </div>
    
    <vx-card class="">
        <!-- <v-select class="searchSelect" placeholder="검색조건"  :value="page.pageSize" v-model='page.pageSize' :clearable="false" :options="optionData.showNumber"/> -->
         
        <div>
            <vue-good-table
                :columns="genreTable.column"
                :rows="tableData"
                :scroll-width="1600"
                >
                    <template slot="table-row" slot-scope="props">
                        <span v-if="props.column.field == 'title'" @click="$router.push('/support/notice/'+props.row.id)" style="cursor:pointer; color:#4a90e2">
                            {{props.row.title}}
                        </span>
                        <span v-else-if="props.column.field == 'visible'">
                            <vs-button style="width:70px;" color="danger" class="btnSmall m-1" @click="genreDelete(props.row.id)" >삭제</vs-button> 
                        </span>
                    </template>
            </vue-good-table>
        </div>
        <!-- <div class="paginationBox">
            <base-pagination :page-count="page.totalPage" v-model="page.currentPage"></base-pagination>
        </div> -->
    </vx-card>
    
     
</div>
</template>

<script>
import Vue from 'vue'
import isEmpty from 'lodash/isEmpty'
import { parseISO, format } from 'date-fns'
import optionData from '@/optionData/data'
 
export default {
    name: 'genreList',
  
    data () {
        return {
            keywordType: 'title',
            keyword: '',
            keywordOptions: [
                { value: 'title', label: '제목' },
            ],
            total : 0,
            page: {
                pageSize : 10,
                currentPage: 1,                       // 현재 페이지
                totalPage: 0,                         // 총 페이지수
            },
            tableData : [],
            genreTable : {
                column : [
                     
                    {label: '순서',    field: 'sequence_nr', sortable: false, filter: false,width:'100px' },
                    {label: '언어',    field: 'language_code', sortable: false, filter: false,width:'100px' },
                    {label: '제목',    field: 'title', sortable: false, filter: false, },
                    {label: '등록일', field: 'created_at', sortable: false, filter: false,minWidth: 140,width:'200px' , formatFn: (data) => {
                        return this.fixDate(data, 'yyyy-MM-dd')
                    }},
                   
                ]
            }
        }
    },
    created(){
        if(this.$route.query.page){
            this.page.currentPage= Number(this.$route.query.page)
        }
        if(this.$route.query.keywordType){
            this.keywordType= this.$route.query.keywordType
        }
        if(this.$route.query.keyword){
            this.keyword= this.$route.query.keyword
        }
        
    },
    mounted(){
        this.$nextTick(() =>{
         this.callList()
        })
    },
    computed: {
    
    },
    watch: {
        'page.currentPage'(e){
            
            this.callList()
        },
        'page.pageSize'(){
            this.list_search()
        }
    },
    methods: {
        list_search(){
            this.page.currentPage = 1
            this.callList()
        },
        searchReset(){
            this.keyword = ''
            this.keywordType = 'title'
            this.list_search()
        },
        callList(){
            const option = {
                sort: 'sequence_nr',
                sortorder: 'desc',
                page: this.page.currentPage-1 ,
                limit: this.page.pageSize,
                //is_various_artists: false, // 필수 filter
            }
            
            let query = {}

            if(this.page.currentPage != 1){
                query['page'] = this.page.currentPage
            }
            if(this.keywordType && !this.valCheck(this.keyword) ) {
                option[this.keywordType] = this.keyword
                query['keywordType'] = this.keywordType
                query['keyword'] = this.keyword
            }   
            this.$router.replace({query: query}).catch((e)=>{});
            
            this.loadingShow()

            this.$store.dispatch('LIST_NOTICE', option)
            .then(result =>{
                this.loadingHide()
                this.tableData  = result.items // 권리자 목록
                
                this.total = result.total // 총인원수 
                this.filtered = result.filtered // limit에 따른 수
                //페이지 수
                const remainder = parseInt(this.filtered % this.page.pageSize) > 0? 1: 0
                this.page.totalPage = parseInt(this.filtered/this.page.pageSize) + remainder
            }).catch(error=>{
                const status = error.response.status
                this.loadingHide()
                switch(status){
                    
                    case 401:
                    this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                    break;
                    default:
                        this.alert({msg : error.response.data.message})
                    break;
                }
            })
        },
        
         

       
    }
}
</script>

<style scoped>

</style>
